// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__A2l94","active":"button_active__DbaCo"};